import { Stack } from '@mui/material';
import Labels from './ContactDetails/Components/SelectLabel';
import Dropzone from '@Components/Common/Dropzone';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface UploadContactsProps {
    control: Control<FieldValues>;
}

const UploadContacts = ({ control }: UploadContactsProps) => {
    const { t } = useTranslation();
    return (
        <Stack spacing={2}>
            <Controller
                name="data"
                control={control}
                render={({ field: { name, onChange } }) => (
                    <Dropzone
                        primaryText={t('Upload Your Contacts')}
                        secondaryText={t('supportedFiles', {
                            files: '.xlsx, .xls, .csv',
                        })}
                        onChange={v => onChange({ target: { value: v }, name })}
                    />
                )}
            />
            <Controller
                name="labels"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Labels
                        selectedLabels={value || []}
                        addLabel={label => {
                            const newLabels = [...(value || []), label];
                            onChange(newLabels);
                        }}
                        removeLabel={label => {
                            const newLabels = (value || []).filter(
                                l => l.name !== label.name,
                            );
                            onChange(newLabels);
                        }}
                    />
                )}
            />
        </Stack>
    );
};

export default UploadContacts;
